<template>
  <header>
    <div class="header-inner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: lastRoute.path }">{{ lastRoute.title }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `guide?employId=${employId}` }"
          v-if="employId && $route.path !== '/guide'">办事指南</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['title', 'employId'],
  computed: {
    lastRoute() {
      const lastRoute = JSON.parse(localStorage.getItem('lastRoute'))
      return lastRoute || { path: '/home', title: '首页' }
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 66px;
  background: $mainColor;
  position: fixed;
  z-index: 1;
  display: flex;

  .header-inner {
    width: var(--inner-width);
    margin: auto;

    ::v-deep.el-breadcrumb {

      font-size: 20px;

      &__inner {
        color: #fff;

        &:hover {
          color: #fff;
        }
      }
    }
  }
}
</style>